package com.xtream.data_kmp.dto


 import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonTransformingSerializer

@kotlinx.serialization.Serializable

data class VodInfo(
    @SerialName("info")
    @Serializable(AlwaysJsonObjectSerializer::class)
    val info: InfoExt?=null,
    @SerialName("movie_data")
    val movie_data: MovieData?=null
) {

    @kotlinx.serialization.Serializable
    
    data class MovieData(
        val added: String? = null,
        val category_id: String,
        val container_extension: String,
        val custom_sid: String? = null,
        val direct_source: String? = null,
        val name: String? = null,
        val stream_id: Int
    )



}

// Extension function approach (recommended)
fun VodInfo.MovieData.toVodStream(): VodStream = VodStream(
    added = this.added.orEmpty(),
    categoryId = this.category_id.toIntOrNull() ?: -1,
    customSid = this.custom_sid,
    directSource = this.direct_source,
    name = this.name.orEmpty(),
    streamId = this.stream_id,
    streamIcon = null,
    streamType = "",
    containerExtension = this.container_extension
)

object AlwaysJsonObjectSerializer : JsonTransformingSerializer<InfoExt>(InfoExt.serializer()) {

    override fun transformDeserialize(element: JsonElement): JsonElement {
        // If it's already a JsonObject, return as-is
        return element as? JsonObject ?: JsonObject(emptyMap()) // fallback to empty object
    }
}
